import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  BillingContactFormShape,
  makeAddressFormGroup,
  makeContactNumberFormGroup,
  makeEmailAddressFormGroup,
} from '../patient-form.service';

// Billing contact section: scalar identity fields + three FormArrays for
// contact methods. The "Same As Patient" copy needs source data from the
// patient-side FormGroups, which this component does not own — it emits the
// click as an output so the host form can run the copy with full context.
@Component({
  selector: 'app-patient-billing-contact-fieldset',
  templateUrl: './patient-billing-contact-fieldset.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PatientBillingContactFieldsetComponent {
  readonly group = input.required<FormGroup<BillingContactFormShape>>();

  readonly sameAsPatient = output<void>();

  get contactNumbers() { return this.group().controls.billingContactContactNumbers; }
  get emailAddresses() { return this.group().controls.billingContactEmailAddresses; }
  get addressDetails() { return this.group().controls.billingContactAddressDetails; }

  addContactNumber(): void { this.contactNumbers.push(makeContactNumberFormGroup()); }
  removeContactNumber(i: number): void { this.contactNumbers.removeAt(i); }

  addEmailAddress(): void { this.emailAddresses.push(makeEmailAddressFormGroup()); }
  removeEmailAddress(i: number): void { this.emailAddresses.removeAt(i); }

  addAddress(): void { this.addressDetails.push(makeAddressFormGroup()); }
  removeAddress(i: number): void { this.addressDetails.removeAt(i); }

  emitSameAsPatient(): void { this.sameAsPatient.emit(); }
}
